import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import ShowEntityData from '../Elements/ShowEntityData';
import FreelancerUserItem from './FreelancerUserItem';
import FreelancerUserService from '../Services/FreelancerUserService';
import FreelancerFeeItem from './FreelancerFeeItem';
import FreelancerFeeService from '../Services/FreelancerFeeService';
import moneyHelper from '../Helpers/moneyHelper';
import JsxHelper from '../Helpers/JsxHelper';
import FaIcon from '../Elements/FaIcon';
import Link from '../Elements/link';
import FreelancerUserAdmin from '../Contents/FreelancerInvoicing/FreelancerUserAdmin/FreelancerUserAdmin';
import FreelancerInvoiceAdmin from '../Contents/FreelancerInvoicing/FreelancerInvoices/FreelancerInvoiceAdmin';
import FreelancerFeeAdmin from '../Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeAdmin';
import dateTimeHelper from '../Helpers/datetimeHelper';
import TabListTable from '../Elements/TabListTable';
import AssignmentItem from './AssignmentItem';
import FeeTypesEnum from '../Enums/FeeTypesEnum';
import TpJobItem from './ThirdParty/TpJob/TpJobItem';
import TpJobService from '../Services/TpJobService';

export default class FreelancerPayableAssignment {
  constructor(item) {
    if (item === undefined) {
      this.FreelancerPayableAssignmentsId = null;
      this.AssignmentId = null;
      this.TpJobId = null;
      this.FreelancerUserId = null;
      this.FreelancerFeeId = null;
      this.Type = '';
      this.Status = '';
      this.FreelancerInvoiceId = null;
      //this.CreatedBy = null;
      this.CreatedOn = null;
      this.FreelancerUserName = '';
      this.EvaluatorName = '';
      this.SelfAssigned = '';
      this.CallsEmails = '';
      this.FreelancerFeeFee = '';
      this.FreelancerUserCurrencyCode = '';
      //this.FreelancerUserOfficeName = '';
      //this.FreelancerFeeFeeType = '';
      this.UseOptFee = '';
      //this.AssignmentSassieId = '';
      this.ThirdPartyJobId = '';
      this.ThirdPartySource = '';
      this.OldStatus = '';
      this.NewStatus = '';
      this.EventTimeStamp = '';
      this.ReviewId = '';
      this.ClientName = '';
      this.ClientSassieId = '';
      this.ThirdPartyClientId = '';
      this.SurveyName = '';
      this.ApolloSurveyId = '';
      this.ThirdPartySurveyId = '';
      this.AssignmentEvaluatorAssignedDate = '';
      //this.WaveName = '';
      //this.ApolloWaveId = '';
      //this.ThirdPartyWaveId = '';
      //this.ApolloAssignmentId = '';
      this.SameIndividual = false;
      this.FreelancerUserPayIfSame = false;
    } else {
      this.initialize(item);
    }
    this.Selected = false;
  }

  async initialize(item) {
    this.FreelancerPayableAssignmentsId = item.freelancerPayableAssignmentsId;
    this.AssignmentId = item.assignmentId;
    this.TpJobId = item.tpJobId;
    this.FreelancerUserId = item.freelancerUserId;
    this.FreelancerFeeId = item.freelancerFeeId;
    this.Type = item.type;
    this.Status = item.status;
    this.FreelancerInvoiceId = item.freelancerInvoiceId;
    //this.CreatedBy = item.createdBy;
    this.CreatedOn = item.createdOn;
    this.FreelancerUserName = item.freelancerUserName;
    this.EvaluatorName = item.evaluatorName;
    this.SelfAssigned = item.selfAssigned;
    this.CallsEmails = item.callsEmails;
    this.FreelancerFeeFee = item.freelancerFeeFee;
    this.FreelancerUserCurrencyCode = item.freelancerUserCurrencyCode;
    //this.FreelancerUserOfficeName = item.freelancerUserOfficeName;
    //this.FreelancerFeeFeeType = item.freelancerFeeFeeType;
    this.UseOptFee = item.useOptFee;
    //this.AssignmentSassieId = item.assignmentSassieId;
    this.ThirdPartyJobId = item.thirdPartyJobId ? item.thirdPartyJobId : item.assignmentSassieId;
    this.ThirdPartySource = item.thirdPartySource ? item.thirdPartySource : 'Apollo';
    this.OldStatus = item.oldStatus;
    this.NewStatus = item.newStatus;
    this.EventTimeStamp = item.eventTimeStamp;
    this.ReviewId = item.reviewId;
    this.ClientName = item.clientName;
    this.ClientSassieId = item.clientSassieId;
    this.ThirdPartyClientId = item.thirdPartyClientId;
    this.SurveyName = item.surveyName;
    this.ApolloSurveyId = item.apolloSurveyId;
    this.ThirdPartySurveyId = item.thirdPartySurveyId;
    this.AssignmentEvaluatorAssignedDate = item.assignmentEvaluatorAssignedDate;
    //this.WaveName = item.waveName;
    //this.ApolloWaveId = item.apolloWaveId;
    //this.ThirdPartyWaveId = item.thirdPartyWaveId;
    //this.ApolloAssignmentId = item.apolloAssignmentId;
    this.SameIndividual = item.sameIndividual;
    this.FreelancerUserPayIfSame = item.freelancerUserPayIfSame;
  }

  static NameOfTheIdField() {
    return 'FreelancerPayableAssignmentsId';
  }
  static nameOfTheItemDetailList(item) {
    return `Vendor Payable Assignments (VPA_ID: ${item.FreelancerPayableAssignmentsId}, Third Party Job ID: ${
      item.ThirdPartyJobId ? `${item.ThirdPartyJobId} - ${item.ThirdPartySource}` : item.AssignmentSassieId
    })`;
  }

  static MoneyFields = ['FreelancerFeeFee'];

  static Currency() {
    return 'FreelancerUserCurrencyCode';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'FreelancerUserCurrencyCode';
  }

  static DateFields = ['CreatedOn', 'EventTimeStamp'];

  static BoolFields = ['UseOptFee'];

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        {
          name: FreelancerPayableAssignment.getFreelancerNameCellContent,
          label: 'Vendor Name (ID)',
        },
        { name: 'EvaluatorName', label: 'Evaluator Name' },
        {
          name: (item) => FreelancerPayableAssignment.getStatusValue(item.Status),
          label: 'Status',
        },
        { name: 'CreatedOn', label: 'Created On' },
        {
          name: (item) => FreelancerPayableAssignment.getTypeText(item),
          label: 'Type',
        },
        { name: 'UseOptFee', label: 'Use Optional Fee' },
        { name: 'ReviewId', label: 'ReviewId' },
        { name: '-', label: 'Info' },
        { name: FreelancerPayableAssignment.getClientName, label: 'Client (Bravo ID)' },
        { name: FreelancerPayableAssignment.getSurvyName, label: 'Survey' },
        { label: '', name: '', className: 'text-left' },
        {
          name: FreelancerPayableAssignment.getStatus,
          label: 'From - To Status',
        },
        { name: 'EventTimeStamp', label: 'Event Time Stamp' },
        {
          name: (item) => dateTimeHelper.toYYYYsMMsDD(item.AssignmentEvaluatorAssignedDate),
          label: 'Date Assigned',
        },
        {
          name: (item) => moneyHelper.toMoneyFormat(item.FreelancerFeeFee, item.FreelancerUserCurrencyCode),
          label: 'Fee',
        },
        {
          name: (item) => JsxHelper.YesNo(item.SelfAssigned),
          label: 'Self Assigned',
          className: 'text-center',
        },
        {
          name: (item) => JsxHelper.YesNo(item.CallsEmails),
          label: 'CallsEmails',
          className: 'text-center',
        },
        {
          name: FreelancerPayableAssignment.getFreelancerFeeIdCellContent,
          label: 'Fee ID',
        },
      ],
    },

    {
      tabName: 'FreelancerUser',
      tabLabel: 'Vendor',
      icon: 'fa-solid fa-swimmer',
      data: [
        {
          name: FreelancerPayableAssignment.getFreelancerUserContent,
          label: 'Vendor',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'FreelancerFee',
      tabLabel: 'Vendor Fee',
      icon: 'fa-solid fa-lightbulb-dollar',
      data: [
        {
          name: FreelancerPayableAssignment.getFreelancerFeeContent,
          label: 'Vendor Fee',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Assignment',
      tabLabel: 'Assignment',
      icon: 'fa-solid fa-lightbulb-dollar',
      hidden: (item) => !item.AssignmentId,
      data: [
        {
          name: FreelancerPayableAssignment.getAssignmentContent,
          label: 'Assignment',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'TpJob',
      tabLabel: 'TP Job',
      icon: 'fa-solid fa-lightbulb-dollar',
      hidden: (item) => !item.TpJobId,
      data: [
        {
          name: FreelancerPayableAssignment.getTpJobContent,
          label: 'TP Job',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static getFreelancerUserContent(item) {
    return (
      <ShowEntityData
        itemId={item.FreelancerUserId}
        entityName='Vendor'
        type={FreelancerUserItem}
        serviceGetByIdFunction={FreelancerUserService.GetFreelancerUserById}
      />
    );
  }

  static getFreelancerFeeContent(item) {
    return (
      <ShowEntityData
        itemId={item.FreelancerFeeId}
        entityName='Vendor Fee'
        type={FreelancerFeeItem}
        serviceGetByIdFunction={FreelancerFeeService.GetFreelancerFeeById}
      />
    );
  }

  static getAssignmentContent(item) {
    item.AsId = item.AssignmentId;
    return (
      <TabListTable
        caption={AssignmentItem.nameOfTheItemDetailList(item)}
        data={item}
        moneyFields={AssignmentItem.MoneyFields}
        moneyFieldsSecondary={this.MoneyFieldsSecondary}
        dateFields={AssignmentItem.DateFields}
        currency={item[AssignmentItem.Currency()]}
        currencySecondary={item[AssignmentItem.CurrencySecondary()]}
        fieldsToShow={AssignmentItem.FieldsToShowInListTable}
        boolFields={AssignmentItem.BoolFields}
        selected={item}
        type={AssignmentItem}
        clickOnCancel={() => {
          this.setState({ selected: -1 });
        }}
      />
    );
  }

  static getTpJobContent(item) {
    return (
      <ShowEntityData
        itemId={item.TpJobId}
        entityName='TPJob'
        type={TpJobItem}
        serviceGetByIdFunction={TpJobService.GetById}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: FreelancerPayableAssignment.getSelectedCellHeader,
        orderById: '',
        data: FreelancerPayableAssignment.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Id',
        orderById: 'FreelancerPayableAssignmentsId',
        data: 'FreelancerPayableAssignmentsId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 80,
      },
      {
        label: 'Third Party Job ID',
        orderById: 'ThirdPartyJobId',
        data: 'ThirdPartyJobId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Third Party Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Client',
        orderById: 'Client',
        data: 'ClientName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Survey',
        orderById: 'SurveyName',
        data: 'SurveyName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Vendor Name',
        orderById: 'FreelancerUserName',
        data: 'FreelancerUserName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Evaluator Name',
        orderById: 'EvaluatorName',
        data: 'EvaluatorName',
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Date (Event/Assigned)',
        orderById: 'Timestamp',
        data: FreelancerPayableAssignment.getTimeStampCellContent,
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Fee',
        orderById: 'FreelancerFee',
        data: (item) =>
          item.FreelancerFeeId ? (
            moneyHelper.toMoneyFormat(item.FreelancerFeeFee, item.FreelancerUserCurrencyCode)
          ) : !item.SameIndividual || item.FreelancerUserPayIfSame ? (
            ''
          ) : (
            <FaIcon
              iconName={'fa-regular fa-shield-exclamation fa-lg color-orange'}
              tooltipText={'Vendor and Evaluator cannot be the same!'}
            />
          ),
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      { label: 'Type', orderById: 'Type', data: FreelancerPayableAssignment.getInfoCellContent },
      {
        label: 'Status',
        orderById: 'Status',
        data: 'Status',
        type: FieldTypesEnum.PureDataField,
      },
    ];
  }

  static getInfoCellContent(item) {
    return <span>{FreelancerPayableAssignment.getTypeIcon(item.Type)}</span>;
  }

  static selectedStatus() {
    return false;
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={FreelancerPayableAssignment.selectedStatus()}
          onChange={(e) => {
            FreelancerPayableAssignment.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
  static clickOnGlobalSelect(item, selected) {}

  static getStatusValue(status) {
    if (status === 'ReadyForInvoicing') return 'Ready For Invoicing';

    if (status === 'OnDraftInvoice') return 'On Draft Invoice';

    return status;
  }

  static getTypeIcon(type) {
    return (
      <FaIcon
        iconName={type === FeeTypesEnum.DQ ? 'fa-solid fa-clipboard-check' : 'fa-regular fa-user-clock'}
        className='infoButton'
        tooltipText={type}
      />
    );
  }

  static getFreelancerFeeIdCellContent(item) {
    if (!item.FreelancerFeeId) return null;

    return (
      <Link
        linktext={item.FreelancerFeeId}
        title='Fees'
        link={<FreelancerFeeAdmin freelancerFeeId={item.FreelancerFeeId} />}
        className='link linknodecoration'
        iconName='fa-solid fa-lightbulb-dollar'
        tooltipText={`Fee Id: ${item.FreelancerFeeId}`}
        url={`freelancer_freelancerfees/search?FreelancerFeeId=${item.FreelancerFeeId}&Office=`}
      />
    );
  }

  static getUseOptFeeCellContent(item) {
    if (!item.UseOptFee) return null;
    return (
      <FaIcon
        iconName='fa-regular fa-funnel-dollar'
        tooltipText='Optional Fee'
      />
    );
  }

  static getFreelancerInvoiceIdCellContent(item) {
    if (!item.FreelancerInvoiceId) return null;
    return (
      <Link
        title='Invoices'
        link={<FreelancerInvoiceAdmin freelancerInvoiceId={item.FreelancerInvoiceId} />}
        className='link linknodecoration'
        iconName='fa-solid fa-file-invoice-dollar'
        tooltipText={`Invoice Id: ${item.FreelancerInvoiceId}`}
        url={`freelancer_invoices/search?FreelancerInvoiceId=${item.FreelancerInvoiceId}`}
      />
    );
  }

  static getTypeText(item) {
    return item.Type === FeeTypesEnum.DQ ? (
      <span className='fa-solid fa-clipboard-check'> Data Quality</span>
    ) : (
      <span className='fa-regular fa-user-clock'> Resource</span>
    );
  }

  static getClientName(item) {
    return `${item.ClientName} (${item.ThirdPartyClientId ?? item.ClientSassieId})`;
  }

  static getSurvyName(item) {
    return `${item.SurveyName} (${item.ApolloSurveyId ?? item.ThirdPartySurveyId})`;
  }

  static getStatus(item) {
    return `${item.OldStatus ? item.OldStatus : 'N/A'} - ${item.NewStatus ? item.NewStatus : 'N/A'}`;
  }

  static getFreelancerNameCellContent(item) {
    return (
      <Link
        linktext={`${item.FreelancerUserName} (${item.FreelancerUserId})`}
        title='Vendors'
        link={<FreelancerUserAdmin freelancerUserId={item.FreelancerUserId} />}
        className='link'
        iconName='fa-solid fa-person-swimming'
        url={`freelancer/search?FreelanceUserId=${item.FreelancerUserId}&OfficeName=`}
      />
    );
  }

  static clickOnSelect(item, selected) {}

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            FreelancerPayableAssignment.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getTimeStampCellContent(item) {
    return item.Type === FeeTypesEnum.RM
      ? dateTimeHelper.toYYYYsMMsDD(item.AssignmentEvaluatorAssignedDate)
      : item.Type === FeeTypesEnum.DQ
      ? dateTimeHelper.toYYYYsMMsDD(item.EventTimeStamp)
      : item.Type;
  }

  static getActionsContent(item) {
    const classNameForIcons = 'link';
    return (
      <div className='text-center'>
        <FaIcon
          className={classNameForIcons}
          iconName='fa-solid fa-eraser'
          onClick={() => FreelancerPayableAssignment.clickOnRemoveFromInvoiceIcon(item.FreelancerPayableAssignmentsId)}
          tooltipText='Remove from Invoice'
          disabled={item.Status !== 'OnDraftInvoice'}
        />
      </div>
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };
}
